// extracted by mini-css-extract-plugin
export default {"container":"djYFvd4aNB","name":"iVXnd6-j1Q","image":"gmA45pq-lx","info":"VcGST1JxF8","info-item":"Om6NC4QevF","infoItem":"Om6NC4QevF","description":"kblZuuE3of","links":"ARVfu1OWtA"};